import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

export const transformRemotesUrl = (url: string) => {
  const version = process.env.APPLICATION_VERSION ?? 'local';
  const buildId = process.env.APPLICATION_UNIQUE_BUILD_ID ?? 'local';

  if (version === 'local') {
    return `${window.location.origin}/remotes/remotes.qa.us.json`;
  }
  if (version.includes('PR')) {
    return `${getAccOrigin()}/previews/exo/${version}/remotes/remotes.qa.us.json?buildId=${buildId}`;
  }
  return `${url}?version=${version}`;
};
